export default {"src":"https://static.eleduck.com/_next/static/media/duck.7d59c58f.svg","height":304,"width":316,"blurWidth":0,"blurHeight":0};